import { render } from "./FolderUsersModal.vue?vue&type=template&id=aaeaf962&scoped=true&ts=true"
import script from "./FolderUsersModal.vue?vue&type=script&lang=ts"
export * from "./FolderUsersModal.vue?vue&type=script&lang=ts"

import "./FolderUsersModal.vue?vue&type=style&index=0&id=aaeaf962&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aaeaf962"]])

export default __exports__